export default __webpack_public_path__ + "static/media/laptop.cb2560e3.png";